/*=========================================================================================
  File Name: module-invoicetrial.js
  Description: InvoiceTrial Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBotTrials
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-invoicetrial-state';
import mutations from './module-invoicetrial-mutations';
import actions from './module-invoicetrial-actions';
import getters from './module-invoicetrial-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
